__turbopack_context__.v({
  "accent": "contact-page-module__Sma-Na__accent",
  "artwork": "contact-page-module__Sma-Na__artwork",
  "artworkNote": "contact-page-module__Sma-Na__artworkNote",
  "chatIcon": "contact-page-module__Sma-Na__chatIcon",
  "chatNote": "contact-page-module__Sma-Na__chatNote",
  "contactReveal": "contact-page-module__Sma-Na__contactReveal",
  "contactSection": "contact-page-module__Sma-Na__contactSection",
  "cutout": "contact-page-module__Sma-Na__cutout",
  "formSurface": "contact-page-module__Sma-Na__formSurface",
  "halo": "contact-page-module__Sma-Na__halo",
  "hero": "contact-page-module__Sma-Na__hero",
  "intro": "contact-page-module__Sma-Na__intro",
  "nexusScene": "contact-page-module__Sma-Na__nexusScene",
  "page": "contact-page-module__Sma-Na__page",
});
